import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import classes from "./FormContentCard.module.css";

const FormContentCard = ({ children, title, titleComponent, description }) => {
    return (
        <div className={classes.contentCard}>
            <div className={classes.title}>
                <Typography variant="h6">{title}</Typography>
                {titleComponent}
            </div>
            <div className={classes.content}>
                {description && (
                    <Typography className={classes.description}>{description}</Typography>
                )}
                {children}
            </div>
        </div>
    );
};

export default FormContentCard;

FormContentCard.propTypes = {
    children: PropTypes.node,
    title: PropTypes.string,
    titleComponent: PropTypes.node,
    description: PropTypes.string,
};
